import React from 'react';
import { Sheet } from 'react-modal-sheet';
import styles from './index.module.css';

const errorIcon = '/assets/icons/error-exclamation.svg';

interface ConsentErrorSheetProps {
  visible: boolean;
  onClose: () => void;
  onRetry?: () => void;
  description?: string;
  showRetry?: boolean;
}

const ConsentErrorSheet: React.FC<ConsentErrorSheetProps> = ({
  visible,
  onClose,
  onRetry,
  description = 'Apologies for the technical issues. Please retry fetching credit information again.',
  showRetry = true,
}) => {
  return (
    <Sheet isOpen={visible} onClose={onClose} detent="content-height">
      <Sheet.Container className={styles.sheetContainer}>
        <Sheet.Content className={styles.sheetContent}>
          <div className={styles.errorSheetContainer}>
            {/* Content */}
            <div className={styles.content}>
              {/* Error Icon */}
              <div className={styles.iconContainer}>
                <img src={errorIcon} alt="Error" width="35" height="35" />
              </div>

              {/* Error Message */}
              <div className={styles.errorTitle}>Something went wrong!</div>
              <div className={styles.errorDescription}>
                {description}
              </div>
            </div>

            {/* Button */}
            <div className={styles.buttonContainer}>
              <button className={styles.retryButton} onClick={showRetry ? onRetry : onClose}>
                {showRetry ? 'Retry' : 'Close'}
              </button>
            </div>
          </div>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop className={styles.sheetBackdrop} onTap={onClose} />
    </Sheet>
  );
};

export default ConsentErrorSheet;
